import { gql } from 'app/graphql';

export const RECORD_FUB_OUTBOUND_INQUIRY = gql(`
    mutation RecordFubOutboundInquiry($input: RecordOutboundInquiryInput!) {
        followUpBoss {
            recordOutboundInquiry(input: $input)
        }
    }
`);

export const RECORD_CHILD_INVITE = gql(`
    mutation RecordChildInvite($recipientEmail: String!, $message: String) {
        followUpBoss {
            recordChildInvite(recipientEmail: $recipientEmail, message: $message)
        }
    }
`);

export const SYNC_CUSTOMER_TO_FUB = gql(`
    mutation SyncCustomerToFub {
        followUpBoss {
            syncCustomerToFub
        }
    }
`);
